/**
 * SchemaValidationItemError is to be used to identify errors
 * with the JSON output from a csv conversion
 */
export class SchemaValidationItemError extends Error {
    /**
     *
     * @param message Error message
     * @param column column name
     */
    constructor(
        message: string,
        public readonly column: string,
        public readonly row: number,
        public readonly type: "missing" | "other" | "too_big",
        public readonly value?: string
    ) {
        super(message)
        this.name = "SchemaValidationItemError"
    }
}
